/* eslint-disable max-len */
import { LocationsModuleMessages, TranslationLocationsModuleMessages } from "../interfaces";

export const messages: TranslationLocationsModuleMessages = {

  /* region Frontend messages */
  [LocationsModuleMessages.name]: "Nome",
  [LocationsModuleMessages.type]: "Tipo",
  [LocationsModuleMessages.address]: "Logradouro",
  [LocationsModuleMessages.number]: "Número",
  [LocationsModuleMessages.district]: "Bairro",
  [LocationsModuleMessages.county]: "Cidade",
  [LocationsModuleMessages.state]: "Estado",
  [LocationsModuleMessages.zipCode]: "CEP",
  [LocationsModuleMessages.regional]: "Regional",
  [LocationsModuleMessages.noNumber]: "S/N",
  [LocationsModuleMessages.noNameRegistered]: "Sem nome cadastrado",
  [LocationsModuleMessages.dataTableTitle]: "locais",
  [LocationsModuleMessages.deleteConfirmationTitle]: "Confirmação de exclusão",
  [LocationsModuleMessages.deleteConfirmationText]: "Deseja realmente excluir o local",
  [LocationsModuleMessages.deactivateConfirmationTitle]: "Local não pode ser excluído",
  [LocationsModuleMessages.deactivateConfirmationText]: "Este local já está vinculado a registros do histórico e por isso não pode ser "
    + "excluído. Deseja inativá-lo? Ele deixa de ser considerado nas regras e nos cadastros, e o histórico é preservado",
  [LocationsModuleMessages.deactivateLocationSuccess]: "Local inativado com sucesso",
  [LocationsModuleMessages.searching]: "Buscando locais...",
  [LocationsModuleMessages.formZipCodeIncomplete]: "CEP incompleto",
  [LocationsModuleMessages.formExternalIdAlreadyRegistered]: "ID externo já cadastrado",
  [LocationsModuleMessages.formTypeRequired]: "O tipo é obrigatório",
  [LocationsModuleMessages.formExternalIdRequired]: "O ID externo é obrigatório para obra e não poderá ser alterado depois",
  [LocationsModuleMessages.formAddressRequired]: "O logradouro é obrigatório",
  [LocationsModuleMessages.formDistrictRequired]: "O bairro é obrigatório",
  [LocationsModuleMessages.formCountyRequired]: "O município é obrigatório",
  [LocationsModuleMessages.formNameRequired]: "O nome é obrigatório",
  [LocationsModuleMessages.formStateRequired]: "O estado é obrigatório",
  [LocationsModuleMessages.toastCoordsNotDefinedTitle]: "Coordenadas não definidas",
  [LocationsModuleMessages.toastCoordsNotDefinedDescription]: "Defina as coordenadas as setando no mapa ou buscando"
  + " pelo CEP",
  [LocationsModuleMessages.toastNoZipCodeDataFoundDescription]: "Nenhum dado encontrado para o cep",
  [LocationsModuleMessages.toastSelectLocationInMapDescription]: "Selecione um local no mapa",
  [LocationsModuleMessages.toastDataLoadedDescription]: "Dados carregados com sucesso!",
  [LocationsModuleMessages.toastLocationModifiedWithoutAddress]: "Local modificado sem alterações de endereço",
  [LocationsModuleMessages.updateConfirmationTitle]: "Confirmação para alteração de dados do endereço",
  [LocationsModuleMessages.updateConfirmationText]: "Deseja alterar os seguintes dados da localização?",
  [LocationsModuleMessages.detailsLocationRegisterTitle]: "Cadastro de locais",
  [LocationsModuleMessages.noNameRegistered]: "Sem nome cadastrado",
  [LocationsModuleMessages.detailsMapPosition]: "Posição no mapa",
  [LocationsModuleMessages.detailsEditLabel]: "Editar",
  [LocationsModuleMessages.externalId]: "ID externo",
  [LocationsModuleMessages.detailsExternalIdHelper]: "Ref. a integrações",
  [LocationsModuleMessages.externalIdLockedOnConstruction]: "Não editável em obra — é a chave usada pela integração",
  [LocationsModuleMessages.integratedConstructionAddressHelper]: "Endereço da integração — ajuste apenas a localização no mapa",
  [LocationsModuleMessages.detailsType]: "Tipo de local",
  [LocationsModuleMessages.detailsRadius]: "Cerca (Raio)",
  [LocationsModuleMessages.detailsRadiusHelper]: "Em metros (m)",
  [LocationsModuleMessages.searching]: "Buscando...",
  [LocationsModuleMessages.detailsSearchZipCode]: "Buscar CEP",
  [LocationsModuleMessages.complement]: "Complemento",
  [LocationsModuleMessages.detailsAllowTravelClosure]: "Permite encerramento de viagem",
  [LocationsModuleMessages.mapButtonConfirmLocation]: "Confirmar localização",
  [LocationsModuleMessages.active]: "Ativo",
  [LocationsModuleMessages.inactive]: "Inativo",
  [LocationsModuleMessages.activeLocation]: "Local ativo",
  /* endregion Frontend messages */
  /* region Backend messages */
  [LocationsModuleMessages.getLocationDataByGoogleSuccess]: "Dados retornados com sucesso",
  [LocationsModuleMessages.getLocationDataByGoogleError]: "Erro ao buscar dados do local",
  [LocationsModuleMessages.readLocationTypeSuccess]: "Tipos de Local(is) retornado(s) com sucesso",
  [LocationsModuleMessages.noLocationTypeFound]: "Nenhum tipo de local cadastrado",
  [LocationsModuleMessages.readLocationTypeError]: "Falha ao buscar tipos de local(is)",
  [LocationsModuleMessages.createLocationSuccess]: "Local(is) cadastrado(s) com sucesso",
  [LocationsModuleMessages.readLocationSuccess]: "Local(is) retornado(s) com sucesso",
  [LocationsModuleMessages.updateLocationSuccess]: "Local alterado com sucesso",
  [LocationsModuleMessages.deleteLocationSuccess]: "Local excluído com sucesso",
  [LocationsModuleMessages.getPlantsLocationsSuccess]: "Usinas retornadas com sucesso",
  [LocationsModuleMessages.createLocationError]: "Falha ao cadastrar local",
  [LocationsModuleMessages.readLocationError]: "Falha ao buscar local(is)",
  [LocationsModuleMessages.noLocationFound]: "Nenhum local cadastrado",
  [LocationsModuleMessages.locationNotFound]: "Local não cadastrado em nosso sistema",
  [LocationsModuleMessages.updateLocationError]: "Falha ao atualizar local",
  [LocationsModuleMessages.deleteLocationError]: "Falha ao excluir local",
  [LocationsModuleMessages.deleteLocationInUse]: "Este local não pode ser excluído porque já está vinculado a registros do histórico "
    + "(viagens, eventos, estados ou alertas). Inative o local para que ele deixe de ser considerado, mantendo o histórico intacto",
  [LocationsModuleMessages.noPlantFound]: "Nenhuma usina cadastrada",
  [LocationsModuleMessages.getPlantsLocationsError]: "Falha ao buscar usinas",
  [LocationsModuleMessages.externalID]: "ID externo",
  [LocationsModuleMessages.createPlantSuccess]: "Usina cadastrada com sucesso",
  [LocationsModuleMessages.createPlantError]: "Falha ao cadastrar usina",
  [LocationsModuleMessages.updatePlantSuccess]: "Usina alterada com sucesso",
  [LocationsModuleMessages.updatePlantError]: "Falha ao alterar usina",
  [LocationsModuleMessages.plantNotFound]: "Usina não cadastrada em nosso sistema",
  [LocationsModuleMessages.deletePlantSuccess]: "Usina excluída com sucesso",
  [LocationsModuleMessages.deletePlantError]: "Falha ao excluir usina",

  /* region Integration messages */
  [LocationsModuleMessages.addressNotFound]: "Endereço(s) não encontrado(s)",
  [LocationsModuleMessages.externalIDAlreadyRegistered]: "ID(s) externo(s) já cadastrado(s)",
  [LocationsModuleMessages.needToInformLocationData]: "Deve ser informado latitude e longitude válidos ou informações do endereço (county, uf, district, ...)",
  [LocationsModuleMessages.noAddressChanges]: "Local não teve mudanças de endereço",
  [LocationsModuleMessages.locationLinkedToAVehicleState]: "Local vinculado a um estado de veículo",
  /* endregion Integration messages */

  /* endregion Backend messages */
  /* region Location Types */
  [LocationsModuleMessages.plant]: "Usina",
  [LocationsModuleMessages.construction]: "Obra",
  [LocationsModuleMessages.autoElectricalWorkshop]: "Auto Elétrica",
  [LocationsModuleMessages.tireRepairShop]: "Borracharia",
  [LocationsModuleMessages.gasStation]: "Posto de Combustível",
  [LocationsModuleMessages.workshop]: "Oficina Mecânica",
  [LocationsModuleMessages.parkingLot]: "Estacionamento",
  [LocationsModuleMessages.others]: "Outros",
  [LocationsModuleMessages.supplier]: "Fornecedor",
  [LocationsModuleMessages.client]: "Cliente",
  /* endregion Location Types */

  /* region Construction consolidation */
  [LocationsModuleMessages.adjustConstruction]: "Ajustar local da obra",
  [LocationsModuleMessages.adjustConstructionTooltip]: "Ajustar o local da obra para o ponto desta descarga e justificar automaticamente os alertas dentro do raio",
  [LocationsModuleMessages.adjustConstructionDischargePoint]: "Descarga indevida",
  [LocationsModuleMessages.adjustConstructionShapeLabel]: "Definir a obra por",
  [LocationsModuleMessages.adjustConstructionRadiusOption]: "Raio",
  [LocationsModuleMessages.adjustConstructionPolygonOption]: "Polígono",
  [LocationsModuleMessages.adjustConstructionRadiusHint]: "Ajuste a área da obra: arraste o círculo, redimensione o raio ou desenhe um polígono. O ponto vermelho marca a descarga indevida. Ao salvar, os alertas pendentes dentro da área serão justificados automaticamente.",
  [LocationsModuleMessages.adjustConstructionPolygonHint]: "Desenhe o polígono da obra no mapa. Ao salvar, a obra passa a valer pela área desenhada e os alertas de descarregamento indevido pendentes dentro do polígono serão justificados automaticamente.",
  [LocationsModuleMessages.adjustConstructionPolygonWarning]: "Esta obra possui um polígono cadastrado. O ajuste pelo pino substitui a geometria da obra: o polígono será removido e a área passa a valer pelo raio. Para usar polígono novamente, escolha \"Polígono\" acima e redesenhe a área.",
  [LocationsModuleMessages.adjustConstructionRadiusField]: "Raio (m)",
  [LocationsModuleMessages.adjustConstructionOptionalHelper]: "Opcional — se vazio, usa",
  [LocationsModuleMessages.adjustConstructionCurrentRadiusSuffix]: "m (raio atual da obra)",
  [LocationsModuleMessages.adjustConstructionDefaultRadiusSuffix]: "m (padrão)",
  [LocationsModuleMessages.adjustConstructionSave]: "Salvar ajuste",
  [LocationsModuleMessages.adjustConstructionDrawFirst]: "Desenhe o polígono da obra no mapa antes de salvar.",
  [LocationsModuleMessages.adjustConstructionNotAConstruction]: "Este local não é uma obra. Apenas obras podem ser ajustadas e consolidadas.",
  [LocationsModuleMessages.adjustConstructionSuccessPrefix]: "Local ajustado —",
  [LocationsModuleMessages.adjustConstructionAlertsJustified]: "alerta(s) justificado(s) automaticamente",
  [LocationsModuleMessages.constructionConsolidatedChip]: "Consolidada",
  [LocationsModuleMessages.constructionConsolidatedTooltip]: "Local consolidado pelas descargas — coordenadas não acompanham mais as entregas",
  [LocationsModuleMessages.locationNameFilter]: "Nome do local",
  [LocationsModuleMessages.viewConstructionTravels]: "Viagens da obra",
  [LocationsModuleMessages.constructionTravelsTitle]: "Viagens da obra",
  [LocationsModuleMessages.constructionTravelsEmpty]: "Nenhuma viagem encontrada para esta obra"
  /* endregion */
};
